import type { Location } from "react-router-dom";

const VALID_BASES = ["/internal-projects", "/projects", "/external-projects"] as const;

/** `ProjectDetail` ile aynı kaynak: state → `lastProjectsBasePath` → varsayılan. */
export function getProjectsBasePathFromLocation(location: Pick<Location, "state">): string {
  const fromState = (location.state as { fromProjectsBasePath?: string } | null)?.fromProjectsBasePath;
  if (fromState && VALID_BASES.includes(fromState as (typeof VALID_BASES)[number])) {
    return fromState;
  }
  if (typeof localStorage !== "undefined") {
    const saved = localStorage.getItem("lastProjectsBasePath");
    if (saved && VALID_BASES.includes(saved as (typeof VALID_BASES)[number])) {
      return saved;
    }
  }
  return "/internal-projects";
}

/**
 * Boş klasör / mesaj ekranları: LineBG + kesik çerçeve için internal | external.
 * Önce gerçek route (internal yolda `.../ext/...` segmenti external yapmamalı), sonra proje listesi kaynağı.
 */
export function getProjectFolderVariantFromLocation(location: Pick<Location, "pathname" | "state">): "internal" | "external" {
  const { pathname } = location;

  /**
   * Kısa entry rotaları: `Routes` içinde `/:projectName/*` — `int` = iç, `ext` = dış (MoveToModal ile aynı).
   * Aksi halde sadece `lastProjectsBasePath` kalır ve dışa geçince `/int/...` sayfaları mor olurdu.
   */
  if (pathname === "/int" || pathname.startsWith("/int/")) {
    return "internal";
  }
  if (pathname === "/ext" || pathname.startsWith("/ext/")) {
    return "external";
  }

  if (pathname.startsWith("/internal-projects") || pathname === "/projects" || pathname.startsWith("/projects/") || pathname.startsWith("/snps")) {
    return "internal";
  }
  if (pathname.startsWith("/external-projects")) {
    return "external";
  }
  if (pathname.includes("/ext/")) {
    return "external";
  }
  return getProjectsBasePathFromLocation(location).includes("external") ? "external" : "internal";
}
